import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlightMealService } from '@common/services/my-booking/flight-meal-service/flight-meal-service';
import { StaticMsgModule } from '@lib/pipes';
import { FlightMealInformationModule } from '../flight-meal-information/flight-meal-information.module';
import { FlightMealTravelerComponent } from './flight-meal-traveler.component';
import { PassengerNameModule } from '@common/pipes';

@NgModule({
  declarations: [FlightMealTravelerComponent],
  imports: [CommonModule, StaticMsgModule, FlightMealInformationModule, PassengerNameModule],
  providers: [FlightMealService],
  exports: [FlightMealTravelerComponent],
})
export class FlightMealTravelerModule {}
